import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import store from './store';
import actions from './actions';
import Utils from 'medscape/utils';
import ErrorHandler from '../error-messages/actions';

export default class EmailForm extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.store = store;
  }
  componentDidMount() { }
  componentWillUpdate() { }
  render() {
    if(this.state["response-messages"].length>0){
      return (
        <h3 className="email-sent">Thank you. An email with this link has been sent.</h3>
      );
    }
    const formProps = {
      id: "email-form",
      noValidate: true,
      onSubmit: (e) => {
        e.preventDefault();
        let postState = $.extend(this.state,this.props);
        let errors = [];
        if(this.state.recipient.length===0 && !this.state.isCopySender){
          errors.push('Please enter a Recipient Address and/or check the Send me a copy checkbox.')
        }
        if(this.state.recipient.length>0 && !Utils.isValidEmail(this.state.recipient)){
          errors.push('Please enter a valid Email Address');
        }
        ErrorHandler.update(errors);
        if(errors.length==0){
          actions.post(this.state);
        }
      }
    }
    const senderProps = {
      id: 'senderName',
      name: 'senderName',
      value: this.props.senderEmail,
      disabled: true,
      type: 'email',
      onChange: (e) => {
        e.preventDefault();
      }
    }
    const recipientProps = {
      onChange: (e) => {
        let el = e.target;
        let $el = $(el);
        let state = {};
        state.recipient = $.trim(el.value);
        this.setState(state);
      },
      type: 'email',
      noValidate: true,
      placeholder: "Enter recipient's email (limit to one)",
      id: name,
      name: name,
      value: this.state.recipient
    }
    const copyCheckboxProps = {
      id: 'copySender',
      name: 'copySender',
      type: 'checkbox',
      value: this.state.isCopySender,
      checked: this.state.isCopySender,
      onChange: (e) => {
        this.setState({
          isCopySender: e.target.checked
        })
      }
    }
    const messageProps = {
      onChange: (e) => {
        this.setState({message: e.target.value});
      },
      value: this.state.message
    }
    return (
            <form {...formProps}>
              <fieldset>
                <div className="subject-container">
                  <label className="heading">Subject</label>
                  <div className="email-title">{this.props.contentTitle}</div>
                </div>
              </fieldset>
              <fieldset>
                <div className="sender-container">
                    <label htmlFor="senderName">From</label>
                    <input {...senderProps } />
                  </div>
              </fieldset>
              <fieldset>
                <div className="recipients-container">
                  <div className="recipient-container">
                      <label htmlFor="recipient">To</label>
                      <input {...recipientProps } />
                    </div>
                    <div className="copy-me-container">
                        <input {...copyCheckboxProps } />
                        <label htmlFor="copySender">Send me a copy</label>
                    </div>
                  </div>
              </fieldset>
              <fieldset>
                <div className="message-container">
                    <label className="email-heading label" htmlFor="email-message">Optional Message</label>
                    <textarea {...messageProps}></textarea>
                </div>
                </fieldset>
                <fieldset>
                  <div className="cta-button-container">
                      <button className="button send-button">Send</button>
                    </div>
                </fieldset>
            </form>
    );
  } // render
}
EmailForm.propTypes={
    contentTitle: React.PropTypes.string,
    subject: React.PropTypes.string,
    linkUrl: React.PropTypes.string,
    senderName: React.PropTypes.string,
    senderEmail: React.PropTypes.string
}
EmailForm.defaultProps={
    contentTitle: "",
    subject: "",
    linkUrl: "",
    senderName: "",
    senderEmail: ""
}



// WEBPACK FOOTER //
// ./medscape_modules/email-modal/form/app.jsx